const en = {
  // Navigation
  nav: {
    home: "Home",
    vision: "Conviction",
    services: "Services",
    articles: "Articles",
    contact: "Contact",
    logoText: "Loïc Blandel",
  },

  // Hero Section
  hero: {
    title: "You Lead.",
    titleHighlight: "",
    statement1: { pre: "You are accountable for ", bold1: "performance", mid: "", bold2: "", post: "." },
    statement2: { pre: "You carry ", bold1: "organisational coherence", post: "." },
    statement3: { pre: "You decide before ", bold1: "certainty exists", post: "." },
    conclusionPre: "That tension is ",
    conclusionBold: "structural",
    conclusionDot: ".",
    emphasis: "Avoiding it weakens the system.",
    cta: "Request a confidential conversation",
    profileAlt: "Loïc Blandel — Executive & Industrial Leadership Performance Advisor",
    manifestoLabel: "EXECUTIVE ADVISOR",
    manifestoText: "Loïc Blandel — ",
    manifestoBold: "Executive & Industrial Leadership Performance Advisor",
    manifestoPost: "",
  },

  // Reality Section → "What Undermines Performance"
  reality: {
    label: "DIAGNOSIS",
    title: "What Undermines Performance",
    s1: { pre: "Not lack of ", bold: "intelligence", post: "." },
    s2: { pre: "Not lack of ", bold: "tools", post: "." },
    s3: { pre: "", bold: "", post: "" },
    s4: { pre: "But structural ", bold: "leadership fragility", post: ":" },
    s5: { pre: "", bold: "", post: "" },
    tensionsTitle: "",
    tensions: [
      { bold: "Decisions postponed", text: " until they become systemic risks" },
      { bold: "Middle management fatigue", text: " that silently erodes output" },
      { bold: "Teams unstable", text: " despite competent leaders" },
      { bold: "Execution gaps", text: " between strategy and operational reality" },
      { bold: "Organisational coherence", text: " deteriorating under pressure" },
    ],
    conclusion1: "Most organisations optimise processes.",
    conclusion2: "Few strengthen leadership structure.",
    conclusion3: "Performance suffers in the gap.",
  },

  // Clients Section → "Who I Advise"
  clients: {
    label: "WHO I ADVISE",
    title: "Who I Advise",
    intro: {
      pre: "",
      bold: "",
      post: "",
      bold2: "",
      post2: "",
    },
    cards: [
      "CEOs",
      "Executive Committee Members",
      "Industrial & Operational Directors",
      "Scaling Founders Under Structural Pressure",
    ],
    commonLabel: "You are responsible for one thing:",
    commonText: "Sustainable performance through others.",
  },

  // Results Section → "My Work"
  results: {
    label: "MY WORK",
    title: "I intervene where leadership directly impacts measurable results",
    intro: {
      pre: "",
      bold1: "",
      mid1: "",
      bold2: "",
      mid2: "",
      bold3: "",
      post: "",
    },
    levels: [
      {
        number: "1",
        title: "Strategic Alignment",
        items: [
          "Clarify what truly matters",
          "Align ambition with operational constraints",
          "Build explicit decision architecture",
        ],
      },
      {
        number: "2",
        title: "Execution Stability",
        items: [
          "Reinforce managerial posture",
          "Reduce decision drift",
          "Stabilise middle management under pressure",
        ],
      },
      {
        number: "3",
        title: "Measurable Impact",
        items: [
          "Improve delivery reliability",
          "Reduce organisational friction",
          "Lower hidden managerial turnover risk",
          "Strengthen collective accountability",
        ],
      },
    ],
    conclusion1: "This is not motivational coaching.",
    conclusion2: "It is structural leadership work.",
  },

  // Framework Section → "Why Me"
  framework: {
    label: "WHY ME",
    title: "Why Me",
    intro: {
      bold1: "15 years inside industrial environments",
      text: " where deadlines are contractual, margins are tight, and human instability affects operational output. This field experience allows me to ",
      bold2: "understand performance pressure from the inside",
      post: ".",
    },
    stats: [
      { label: "Training", value: "Engineer by training", value2: "ICF PCC certified" },
      { label: "Experience", valuePre: "Former manager of teams up to ", accent: "100 people" },
      { label: "Impact", accent: "+100", valuePre: " leaders supported", detail: "Across industrial contexts" },
      { label: "Advisory", accent: "30+", valuePre: " executive advisory engagements" },
      { label: "Certification", certName: "ICF PCC", certDetail: "Professional Certified Coach" },
    ],
  },

  // Cofondateur Section
  cofondateur: {
    title: "Co-Founder",
    unipseDesc: "Leadership and operational transformation",
    cayusDesc: "AI platform measuring leadership maturity and anticipating human risk exposure",
  },

  // Vision Section → "Conviction"
  vision: {
    label: "CONVICTION",
    title: "Demanding excellence is not harshness. It is accountability.",
    intro: "There is no universal leadership model.",
    text: "Effective leadership depends on:",
    items: [
      "Context",
      "Structure",
      "Responsibility",
    ],
    quote1: "Mintzberg showed that management is practice before theory.",
    quote2: "Drucker reminded us its purpose is collective performance.",
    belief1: "My role is not to give you a framework.",
    belief2: "It is to strengthen yours — so it holds under pressure.",
    footerPre: "",
    footerBold1: "",
    footerMid: "",
    footerBold2: "",
    footerPost: "",
  },

  // Accompagnements Section → "How We Work"
  accompagnements: {
    label: "HOW WE WORK",
    title: "How We Work",
    intro: {
      pre: "",
      bold: "",
      post: "",
    },
    cards: [
      {
        title: "Executive Advisory (1:1)",
        description: "Confidential, structured, performance-focused.",
      },
      {
        title: "On-Site Operational Intervention",
        description: "Immersion to stabilise leadership in real conditions.",
      },
      {
        title: "Strategic Sparring Partnership",
        description: "High-level challenge function for critical decisions.",
      },
    ],
  },

  // Testimonials Section
  testimonials: {
    label: "TESTIMONIALS",
    title: "What my clients say",
    intro: "Feedback from executives and managers supported through their operational challenges.",
    featuredBadge: "Detailed testimonial",
    measuredResults: "Measured results",
    cards: [
      {
        name: "Alfonso",
        role: "Plant Director",
        texts: [
          "I had the pleasure of working with Loïc who <strong>inspired</strong> me and helped me find ways to overcome difficult situations.",
          "With Loïc, I was able to develop <strong>managerial skills</strong> and continue to grow in leadership. A journey that never ends.",
        ],
      },
      {
        name: "Geta",
        role: "Industrial Director",
        featured: true,
        texts: [
          "The mission was to support us in our <strong>continuous improvement</strong> processes and strengthen our middle management teams. On both counts, <strong>the challenge was met</strong>.",
          "I greatly appreciated his <strong>intelligent and objective listening</strong>, without dogmatism, to adapt solutions to the reality of our context.",
          "His greatest strength: <strong>giving meaning</strong> to the actions to be taken and always refocusing reflections on the human element.",
        ],
      },
    ],
  },

  // Contact Section
  contact: {
    title: "Leadership Under Pressure Requires Structure.",
    subtitle: "Let's discuss your challenges. Strictly confidential.",
    photoAlt: "Loïc Blandel — Executive & Industrial Leadership Performance Advisor",
    cardTitle: "Loïc Blandel",
    cardSubtitle: "Executive & Industrial Leadership Performance Advisor",
    emailLabel: "Email",
    phoneLabel: "Phone",
    linkedinLabel: "LinkedIn",
  },

  // Footer
  footer: {
    text: "© 2024 Loïc Blandel. All rights reserved.",
  },

  // Articles Page
  articles: {
    backToHome: "Back to home",
    title: "Articles & News",
    subtitle: "Reflections on leadership, management and organizational news",
    all: "All",
    loading: "Loading articles...",
    empty: "No articles published yet.",
    news: "News",
    article: "Article",
    min: "min",
  },

  // Article Detail
  articleDetail: {
    backToArticles: "Back to articles",
    notFound: "Article not found",
    loading: "Loading article...",
    share: "Share",
    copyLink: "Copy link",
    readingTime: "min read",
    by: "By",
    externalNotice: "This article comes from an external source.",
    readOriginal: "Read the original article",
    linkCopied: "Link copied to clipboard!",
  },
};

export default en;
